import type { Reaction } from '../types'
import type { IReactionType } from '../types/IChat'
import { findMessage, getMessageIdentityKey } from '@/modules/chat-matrix-fast/utils/messageIdentity'

/** Снимает повторные префиксы emoji: из Matrix reaction key. */
export function stripEmojiKeyPrefix(value: string | null | undefined): string {
  let result = String(value ?? '').trim()
  while (result.startsWith('emoji:')) {
    result = result.slice(6).trim()
  }

  return result
}

/** Короткий icon как есть, иначе эвристика по icon/name */
export function getReactionEmoji(r: IReactionType): string {
  if (r.icon && r.icon.length <= 3) return r.icon

  const icon = String(r.icon || '').toLowerCase()
  const name = (r.name || '').toLowerCase()

  if (icon.includes('thumb')) return '👍'
  if (icon.includes('heart') || icon.includes('❤')) return '❤️'
  if (icon.includes('laugh') || icon.includes('😂') || icon.includes('😆')) return '😂'
  if (icon.includes('wow') || icon.includes('😮')) return '😮'
  if (icon.includes('sad') || icon.includes('😢')) return '😢'
  if (icon.includes('angry') || icon.includes('😠')) return '😠'
  if (name.includes('счаст')) return '😊'
  if (name.includes('люб') || name.includes('love') || name.includes('heart')) return '❤️'
  if (name.includes('удив') || name.includes('wow')) return '😮'
  if (name.includes('груст') || name.includes('печаль') || name.includes('sad')) return '😢'
  if (name.includes('смеш') || name.includes('смех') || name.includes('laugh')) return '😂'
  if (name.includes('зл') || name.includes('angry')) return '😠'
  if (name.includes('like') || name.includes('лайк') || name.includes('нрав')) return '👍'

  return '👍'
}

export const toggleReaction = async (
  store: any,
  messageId: number | string,
  reactionTypeId: number | string,
  getCurrentReactionTypeId: (message: any) => string | null,
): Promise<void> => {
  const lookup = {
    id: messageId,
    matrixEventId: typeof messageId === 'string' ? messageId : undefined,
  }
  const message = findMessage(store.messages ?? [], lookup)
    || findMessage(store.activeChat?.chat?.messages ?? [], lookup)

  if (!message) {
    return
  }

  const identityKey = getMessageIdentityKey(message)
  const matrixEventIdHint = message.matrix_event_id
  const prevReactionTypeId = getCurrentReactionTypeId(message)

  if (prevReactionTypeId && String(prevReactionTypeId) === String(reactionTypeId)) {
    await store.clearMyReactions(identityKey, matrixEventIdHint)
  } else if (prevReactionTypeId !== null) {
    await store.setExclusiveReaction(identityKey, reactionTypeId, undefined, matrixEventIdHint)
  } else {
    await store.addReaction(identityKey, reactionTypeId, matrixEventIdHint)
  }
}

export const hasUserReaction = (
  reactions: Reaction[] | undefined,
  userId: string | number | undefined,
  reactionTypeId: string | number,
): boolean => {
  if (!reactions || !userId) return false

  return reactions.some(r => {
    const reactionUserId = r.user_id || (r as any).user?.id || (r as any).user
    const currentReactionTypeId = r.reaction_type_id || (r as any).reaction_type || (r as any).type_id

    return (
      String(reactionUserId) === String(userId)
      && String(currentReactionTypeId) === String(reactionTypeId)
    )
  })
}

export const getReactionCount = (
  reactions: Reaction[] | undefined,
  reactionTypeId: string | number,
): number => {
  if (!reactions) return 0

  return reactions.filter(r => {
    const currentReactionTypeId = r.reaction_type_id || (r as any).reaction_type || (r as any).type_id
    return String(currentReactionTypeId) === String(reactionTypeId)
  }).length
}
